import { AfterViewInit, Component, inject } from '@angular/core';
import { Commune } from '../../../models/commune';
import { ComparisonValue } from '../../../models/geo-data';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../../organisms/mask/mask.component';
import { NgIf } from '@angular/common';
import { MenuItem, MessageService, PrimeTemplate } from 'primeng/api';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { BaseListComponent } from '../../organisms/base-list/base-list.component';
import { ComparisonValueStore } from '../../../stores/comparison-value/comparison-value.state';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-configuration-comparison-values',
  standalone: true,
  imports: [
    HeaderComponent,
    MaskComponent,
    NgIf,
    PrimeTemplate,
    RouterOutlet,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    DividerModule,
  ],
  templateUrl: './configuration-comparison-values.component.html',
  styleUrl: './configuration-comparison-values.component.scss',
})
export class ConfigurationComparisonValuesComponent
  extends BaseListComponent<ComparisonValue>
  implements AfterViewInit
{
  readonly store = inject(ComparisonValueStore);
  activeCommune: Commune | null = null;
  override menuItems: MenuItem[] = [];
  override sidebarId = 'comparison-value-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  ngAfterViewInit() {
    return;
  }
}
